import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { Observable, of } from "rxjs";
import { AsyncPipe } from "@angular/common";
import { AlertModule } from "@storeblocks/alert-ng";
import { AccordionModule } from "@storeblocks/accordion-ng";

export enum ExpandableAlertType {
  Default = "default",
  Error = "error",
}

@Component({
  selector: "app-expandable-alert",
  templateUrl: "./expandable-alert.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe, AlertModule, AccordionModule],
})
export class ExpandableAlertComponent {
  public readonly visible$ = input<Observable<boolean>>(of(true));
  public readonly open = input(true);
  public readonly title = input.required<string>();
  public readonly titleOpened = input<string>();
  public readonly titleClosed = input<string>();
  public readonly footerTitle = input.required<string>();
  public readonly footerHtml = input.required<string>();

  public type: ExpandableAlertType = ExpandableAlertType.Default;
  public types = ExpandableAlertType;

  public getTitle(): string {
    const titleOpened = this.titleOpened() || this.title();
    const titleClosed = this.titleClosed() || titleOpened;

    return this.open() ? titleOpened : titleClosed;
  }

  public getIcon(): string {
    return this.type === ExpandableAlertType.Error ? "warning-filled" : "information-filled";
  }
}
